// export type VideoResolution = `${number}x${number}`;

export function generateVideoResolutions(width: number, height: number): string[] {
  const resolutions: string[] = [];
  const aspectRatio = width / height;

  // Стандартные высоты для 480p, 720p, 1080p и т.д.
  const standardHeights = [480, 720, 1080, 1440, 2160];

  for (const h of standardHeights) {
    const w = Math.round(h * aspectRatio);
    if (w <= width && h <= height) {
      resolutions.push(`${w}x${h}`);
    }
  }

  return resolutions;
}
